@if (locationSettings) {
  <div>
    <div class="mb-3">
      @if (location.id.startsWith('C0')) {
        {{ 'SET_DEFAULT_SETTINGS_FOR_EMA' | translate }}
      } @else {
        <!-- Hide this for now, as the functionality cannot be implemented yet
        <mat-checkbox id="default-ema-settings-checkbox" (change)="changeDefaultSettings($event)">
          {{ 'USE_CUSTOMER_DEFAULT_SETTINGS_FOR_EMA' | translate }}
        </mat-checkbox>
        -->
      }
    </div>
    <mat-accordion multi="true">
      <!-- Alert Timeout category -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span><span class="fa-light fa-fw fa-clock"></span> {{'ALERT_TIMEOUTS' | translate}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="alertTimeoutsForm" (ngSubmit)="formSubmitSubject.next('submitAlertTimeoutsForm')">
          <div class="form-group">
            <label>{{'RESERVED_TIMEOUT' | translate}}</label>
            <mat-form-field>
              <mat-select formControlName="reserved">
                @for (option of locationSettings.alertTimers.reserved.options; track option) {
                  <mat-option
                    [value]="option">
                    {{option}} {{'MINUTES' | translate}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label>{{'STARTED_TIMEOUT' | translate}}</label>
            <mat-form-field>
              <mat-select formControlName="started">
                @for (option of locationSettings.alertTimers.started.options; track option) {
                  <mat-option
                    [value]="option">
                    {{option}} {{'MINUTES' | translate}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label>{{'COMPLETED_TIMEOUT' | translate}}</label>
            <mat-form-field>
              <mat-select formControlName="completed">
                @for (option of locationSettings.alertTimers.completed.options; track option) {
                  <mat-option
                    [value]="option">
                    {{option}} {{'MINUTES' | translate}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (!defaultConfigChecked && !viewOnly) {
            <div class="form-group">
              <button type="submit" class="btn btn-primary">
                <span class="fa-light fa-fw fa-floppy-disk"></span>
                {{'SAVE' | translate}}
              </button>
              @if (saveState.alertTimers === 1) {
                <div class="alert alert-success mt-3">
                  {{'CONF_SAVED' | translate}}
                </div>
              }
              @if (saveState.alertTimers === 2) {
                <div class="alert alert-danger mt-3">
                  {{'ERROR' | translate}}
                </div>
              }
            </div>
          }
        </form>
      </mat-expansion-panel>
      <!-- Alert priorities category -->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span><span class="fa-light fa-fw fa-flag"></span> {{'ALERT_PRIORITIES' | translate}}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-accordion multi="true">
          @for (priority of locationSettings.alertPriorities.priorities; track priority) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span><span class="fa-solid fa-fw fa-flag" [style.color]="priority.colour"></span>
                {{'PRIORITY' | translate}} {{priority.priority}}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-group">
              <mat-form-field>
                <mat-select [(ngModel)]="priority.sound" [disabled]="defaultConfigChecked || viewOnly" name="prioritySound"
                  (selectionChange)="playPrioritySound(priority.sound)">
                  @for (option of soundOptions; track option) {
                    <mat-option [value]="option">
                      {{option | translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-selection-list dense="true" [disabled]="defaultConfigChecked || viewOnly" (selectionChange)="alertTypeSelectionChange($event, priority)">
                @for (type of priority.availableAlertTypes; track type) {
                  <mat-list-option [disabled]="type.disabled" [selected]="type.selected"
                    [value]="type.value">
                    {{type.value | translate}}
                  </mat-list-option>
                }
              </mat-selection-list>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>
      @if (!defaultConfigChecked && !viewOnly) {
        <div class="mt-3">
          <!-- Placeholder element for playing priority sound files -->
          <audio id="priorityAudio"></audio>
          <button class="btn btn-outline-primary gray-bg" (click)="submitAlertPriorities()">
            <span class="fa-light fa-fw fa-circle-plus"></span>
            {{'SAVE' | translate}}
          </button>
          @if (saveState.alertPriorities === 1) {
            <div class="alert alert-success mt-3">
              {{'CONF_SAVED' | translate}}
            </div>
          }
          @if (saveState.alertPriorities === 2) {
            <div class="alert alert-danger mt-3">
              {{'ERROR' | translate}}
            </div>
          }
        </div>
      }
    </mat-expansion-panel>
    <!-- Alert notes category -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span>
            <span class="fa-light fa-fw fa-note-sticky"></span>
            {{ (viewOnly ? 'NOTES' : 'ALERT_NOTE_TEMPLATES') | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      @if (locationSettings.alertNotes.notes.length === 0) {
        <div>
          <p>{{'NO_NOTES' | translate}}</p>
        </div>
      }
      @if (locationSettings.alertNotes.notes.length > 0) {
        <div>
          <ul class="alertNotesList">
            @for (note of locationSettings.alertNotes.notes; track note; let i = $index) {
              <li>
                <div class="noteBody float-left">
                  {{note}}
                </div>
                @if (!viewOnly) {
                  <div class="float-left">
                    <span class="fa-light fa-fw fa-lg fa-trash-alt cursorPointerHover"
                      (click)="removeNote(i)">
                    </span>
                  </div>
                }
              </li>
            }
          </ul>
        </div>
      }
      @if (!viewOnly) {
        <form [formGroup]="alertNoteForm" (ngSubmit)="formSubmitSubject.next('submitAlertNoteForm')" class="mt-3">
          <div class="form-group">
            <textarea class="form-control" formControlName="note"></textarea>
          </div>
          <div class="form-group">
            <button [disabled]="!alertNoteForm.valid" class="btn btn-outline-primary gray-bg">
              <span class="fa-light fa-fw fa-circle-plus"></span>
              {{'ADD_NEW_NOTE_TEMPLATE' | translate}}
            </button>
            @if (saveState.alertNotes === 2) {
              <div class="alert alert-danger mt-3">
                {{'ERROR' | translate}}
              </div>
            }
          </div>
        </form>
      }
    </mat-expansion-panel>
    <!-- Alarm options category -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span><span class="fa-light fa-fw fa-bell"></span> {{'ALARM_OPTIONS' | translate}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="alarmOptionsForm" (ngSubmit)="formSubmitSubject.next('submitAlarmOptionsForm')">
        <div class="form-group">
          <label>{{'STARTED_TASK_MUTING' | translate}}</label>
          <mat-form-field>
            <mat-select formControlName="startedTaskMuting">
              @for (option of locationSettings.alarmOptions.startedTaskMuting.options; track option) {
                <mat-option
                  [value]="option">
                  {{option | translate}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-group">
          <label>{{'MINIMUM_VOLUME' | translate}}</label><span matTooltip="{{'MIN_ALARM_VOL_TOOLTIP' | translate}}"
          class="fa fa-info-circle ml-2"></span>
          <mat-form-field>
            <mat-select formControlName="minimumVolume">
              @for (option of locationSettings.alarmOptions.minimumVolume.options; track option) {
                <mat-option
                  [value]="option">
                  {{option}} %
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if (!defaultConfigChecked && !viewOnly) {
          <div class="form-group">
            <button type="submit" class="btn btn-primary"><span class="fa-light fa-fw fa-floppy-disk"></span>
            {{'SAVE' | translate}}</button>
          @if (saveState.alarmOptions === 1) {
            <div class="alert alert-success mt-3">
              {{'CONF_SAVED' | translate}}
            </div>
          }
          @if (saveState.alarmOptions === 2) {
            <div class="alert alert-danger mt-3">
              {{'ERROR' | translate}}
            </div>
          }
        </div>
      }
    </form>
  </mat-expansion-panel>
  <!-- Alert UI category -->
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span><span class="fa-light fa-fw fa-tv"></span> {{'ALERT_UI_SETTINGS' | translate}}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="alertUiForm" (ngSubmit)="formSubmitSubject.next('submitAlertUiForm')">
      <div class="form-group">
        <label>{{'QUICK_ALERT_COMPLETE' | translate}}</label>
        <mat-form-field>
          <mat-select formControlName="quickComplete">
            @for (option of locationSettings.alertUi.quickComplete.options; track option) {
              <mat-option
                [value]="option">
                {{option | translate}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (!defaultConfigChecked && !viewOnly) {
        <div class="form-group">
          <button type="submit" class="btn btn-primary"><span class="fa-light fa-fw fa-floppy-disk"></span>
            {{'SAVE' | translate}}
          </button>
        @if (saveState.alertUi === 1) {
          <div class="alert alert-success mt-3">
            {{'CONF_SAVED' | translate}}
          </div>
        }
        @if (saveState.alertUi === 2) {
          <div class="alert alert-danger mt-3">
            {{'ERROR' | translate}}
          </div>
        }
      </div>
    }
  </form>
</mat-expansion-panel>
</mat-accordion>
@if (defaultConfigChecked && !viewOnly) {
  <div class="mt-3">
    @if (saveState.defaultConfigForms === 1) {
      <div class="alert alert-success mb-2">
        {{'CONF_SAVED' | translate}}
      </div>
    }
    @if (saveState.defaultConfigForms === 2) {
      <div class="alert alert-danger mb-2">
        {{'ERROR' | translate}}
      </div>
    }
    <button class="btn btn-primary" [disabled]="saving" (click)="submitDefaultConfigForms()">
      <span [ngClass]="saving ? 'fa-duotone fa-spinner-third fa-spin' : 'fa-light fa-fw fa-floppy-disk'"></span>
      {{ (saving ? 'SAVING' : 'SAVE') | translate }}
    </button>
  </div>
}
</div>
}
